import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import { v4 as uuidv4 } from 'uuid';

const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const S3_REGION = process.env.REACT_APP_S3_REGION;

const s3Client = new S3Client({
  region: S3_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
  },
});

const uploadFileToS3 = async (file, folderName) => {
  const uuid = uuidv4();
  const splitedFileName = file.name.split('.');
  const fileType = splitedFileName[splitedFileName.length - 1];
  const key = `${folderName}/${uuid}.${fileType}`;

  const fileBuffer = await file.arrayBuffer();

  const params = {
    ACL: 'public-read',
    Body: new Uint8Array(fileBuffer),
    Bucket: S3_BUCKET,
    ContentType: file.type,
    Key: key,
  };

  try {
    await s3Client.send(new PutObjectCommand(params));
    return `https://${S3_BUCKET}.s3.${S3_REGION}.amazonaws.com/${key}`;
  } catch (err) {
    throw new Error('Failed to upload file.');
  }
};

export default uploadFileToS3;
